var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 1C3.05933 1 2.5 1.56 2.5 2.25V13.75C2.5 14.44 3.06 15 3.75 15H12.25C12.94 15 13.5 14.44 13.5 13.75V8.5C13.5 7.83696 13.2366 7.20107 12.7678 6.73223C12.2989 6.26339 11.663 6 11 6H9.75C9.41848 6 9.10054 5.8683 8.86612 5.63388C8.6317 5.39946 8.5 5.08152 8.5 4.75V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1H3.75ZM5 10C5 9.86739 5.05268 9.74022 5.14645 9.64645C5.24021 9.55268 5.36739 9.5 5.5 9.5H10.5C10.6326 9.5 10.7598 9.55268 10.8536 9.64645C10.9473 9.74022 11 9.86739 11 10C11 10.1326 10.9473 10.2598 10.8536 10.3536C10.7598 10.4473 10.6326 10.5 10.5 10.5H5.5C5.36739 10.5 5.24021 10.4473 5.14645 10.3536C5.05268 10.2598 5 10.1326 5 10ZM5.5 11.5C5.36739 11.5 5.24021 11.5527 5.14645 11.6464C5.05268 11.7402 5 11.8674 5 12C5 12.1326 5.05268 12.2598 5.14645 12.3536C5.24021 12.4473 5.36739 12.5 5.5 12.5H8C8.13261 12.5 8.25979 12.4473 8.35355 12.3536C8.44732 12.2598 8.5 12.1326 8.5 12C8.5 11.8674 8.44732 11.7402 8.35355 11.6464C8.25979 11.5527 8.13261 11.5 8 11.5H5.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64844 1.21069C9.19945 1.846 9.50227 2.65906 9.5011 3.50003V4.75003C9.5011 4.88803 9.6131 5.00003 9.7511 5.00003H11.0011C11.8421 4.99886 12.6551 5.30168 13.2904 5.85269C12.9971 4.73717 12.4128 3.71956 11.5972 2.90395C10.7816 2.08834 9.76397 1.504 8.64844 1.21069Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.291f887ca75a7b48559bb21c0d9dee18.svg";
export { ForwardRef as ReactComponent };